const state = {
    isAuthenticated: false,
    authenticating: false,
    authError: null,
    user: null,
};
export default state;
